
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "notifications"
    }}>{`Notifications`}</h1>
    <h2 {...{
      "id": "notifications-from-apache-atlas"
    }}>{`Notifications from Apache Atlas`}</h2>
    <p>{`Apache Atlas sends notifications about metadata changes to Kafka topic named ATLAS_ENTITIES .
Applications interested in metadata changes can monitor for these notifications.
For example, Apache Ranger processes these notifications to authorize data access based on classifications.`}</p>
    <h3 {...{
      "id": "notifications---v2-apache-atlas-version-10"
    }}>{`Notifications - V2: Apache Atlas version 1.0`}</h3>
    <p>{`Apache Atlas 1.0 sends notifications for following operations on metadata.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
   {`ENTITY_CREATE:         sent when an entity instance is created
      ENTITY_UPDATE:         sent when an entity instance is updated
      ENTITY_DELETE:         sent when an entity instance is deleted
      CLASSIFICATION_ADD:    sent when classifications are added to an entity instance
      CLASSIFICATION_UPDATE: sent when classifications of an entity instance are updated
      CLASSIFICATION_DELETE: sent when classifications are removed from an entity instance`}
 </SyntaxHighlighter>
    <p>{`Notification includes the following data.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`AtlasEntity  entity;
   OperationType operationType;
   List<AtlasClassification>  classifications;`}
    </SyntaxHighlighter>
    <h3 {...{
      "id": "notifications---v1-apache-atlas-version-08x-and-earlier"
    }}>{`Notifications - V1: Apache Atlas version 0.8.x and earlier`}</h3>
    <p>{`Notifications from Apache Atlas version 0.8.x and earlier have content formatted differently, as detailed below.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`Operations`}</em></strong></p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
   {`ENTITY_CREATE: sent when an entity instance is created
      ENTITY_UPDATE: sent when an entity instance is updated
      ENTITY_DELETE: sent when an entity instance is deleted
      TRAIT_ADD:     sent when classifications are added to an entity instance
      TRAIT_UPDATE:  sent when classifications of an entity instance are updated
      TRAIT_DELETE:  sent when classifications are removed from an entity instance`}
    </SyntaxHighlighter>
    <p>{`Notification includes the following data.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`Referenceable entity;
   OperationType operationType;
   List<Struct>  traits;`}
    </SyntaxHighlighter>
    <p>{`Apache Atlas 1.0 can be configured to send notifications in older version format, instead of the latest version format.
This can be helpful in deployments that are not yet ready to process notifications in the latest version format.
To configure Apache Atlas 1.0 to send notifications in earlier version format, please set following configuration in atlas-application.properties:`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
 atlas.notification.entity.version=v1
    </SyntaxHighlighter>
    <h2 {...{
      "id": "notifications-to-apache-atlas"
    }}>{`Notifications to Apache Atlas`}</h2>
    <p>{`Apache Atlas can be notified of metadata changes and lineage via notifications to Kafka topic named ATLAS_HOOK.
Atlas hooks for Apache Hive/Apache HBase/Apache Storm/Apache Sqoop use this mechanism to notify Apache Atlas of events of interest.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`ENTITY_CREATE            : create an entity. For more details, refer to Java class HookNotificationV1.EntityCreateRequest
ENTITY_FULL_UPDATE       : update an entity. For more details, refer to Java class HookNotificationV1.EntityUpdateRequest
ENTITY_PARTIAL_UPDATE    : update specific attributes of an entity. For more details, refer to HookNotificationV1.EntityPartialUpdateRequest
ENTITY_DELETE            : delete an entity. For more details, refer to Java class HookNotificationV1.EntityDeleteRequest
ENTITY_CREATE_V2         : create an entity. For more details, refer to Java class HookNotification.EntityCreateRequestV2
ENTITY_FULL_UPDATE_V2    : update an entity. For more details, refer to Java class HookNotification.EntityUpdateRequestV2
ENTITY_PARTIAL_UPDATE_V2 : update specific attributes of an entity. For more details, refer to HookNotification.EntityPartialUpdateRequestV2
ENTITY_DELETE_V2         : delete one or more entities. For more details, refer to Java class HookNotification.EntityDeleteRequestV2`}
    </SyntaxHighlighter>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;